import type { TokenDef } from '../services/interviewLinksApi';

/** German words recruiters type after "/" — the templates are written in German as often as in English. */
const GERMAN_WORDS: Record<string, string> = {
  duration: 'dauer länge laenge minuten',
  bookingLink: 'buchungslink buchung termin link',
  candidateFirstName: 'vorname bewerber kandidat',
  previousInterviewers: 'bisherige gesprächspartner gespraechspartner',
  nextInterviewers: 'gesprächspartner gespraechspartner',
  nextInterviewersWithRoles: 'gesprächspartner gespraechspartner rollen titel',
  roleTitle: 'stelle stellentitel rolle',
  stageName: 'phase stufe runde',
  recruiterName: 'recruiter absender',
};

/** The variables a "/query" in a template editor offers: by name, label or German keyword. */
export function filterTokens(tokens: TokenDef[], query: string): TokenDef[] {
  const q = query.toLowerCase();
  if (!q) return tokens;
  return tokens.filter(
    (t) =>
      t.name.toLowerCase().includes(q) ||
      t.label.toLowerCase().includes(q) ||
      (GERMAN_WORDS[t.name] ?? '').includes(q)
  );
}
